module.exports = __webpack_public_path__ + "shanz/static/media/eastern_banner1.4f246fc7.png";